import React from 'react';
import './NotFound.css';
const NotFound = () => {
    return (
        <div className="NotFound">
            <h1>Sorry! The page you are trying to access is not available</h1>
        </div>
    );
};

export default NotFound;